export default __webpack_public_path__ + "static/media/box 1.852a4141.svg";